import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _RegradeOverride;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { List } from 'immutable';
import { Alert } from '@instructure/ui-alerts';
import { Button } from '@instructure/ui-buttons';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { Text } from '@instructure/ui-text';
import { jsx } from '@instructure/emotion';
import { CustomPropTypes, QuizzesSpinner as Spinner, componentForItem, propsForInteractionEdit, UndecoratedQuizEntryEdit } from '@instructure/quiz-core';
import { COMPONENT_EDIT, PARENT_TYPE_QUIZ, REGRADE_MODAL, withStyleOverrides } from '@instructure/quiz-common';
import RegradingModal from '../../../RegradingModal';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import t from '@instructure/quiz-i18n/es/format-message';
var noop = function noop() {};
export var RegradeOverride = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_RegradeOverride = /*#__PURE__*/function (_Component) {
  function RegradeOverride() {
    var _this;
    _classCallCheck(this, RegradeOverride);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, RegradeOverride, [].concat(args));
    _defineProperty(_this, "handleQuizEntryPointsChange", function (points) {
      var _this$props = _this.props,
        workingQuizEntry = _this$props.workingQuizEntry,
        workingEntry = _this$props.workingEntry;
      var qerIndexToUpdate = workingQuizEntry.quizEntryRegrades.findIndex(function (qer) {
        return qer.get('itemId') == workingEntry.id;
      });
      var newQuizEntryRegrades = qerIndexToUpdate > -1 ? workingQuizEntry.quizEntryRegrades.setIn([qerIndexToUpdate, 'pointsPossible'], null) : workingQuizEntry.quizEntryRegrades;
      _this.props.changeQuizEntryPoints(workingQuizEntry.id, points, newQuizEntryRegrades.toJS());
    });
    _defineProperty(_this, "navigateToTop", function () {
      setTimeout(function () {
        _this.props.screenreaderNotification(t('Focus moved to top of question. Navigate down to continue.'));
        _this.alertNode.focus();
      });
    });
    _defineProperty(_this, "turnOffRegradingEditMode", function () {
      _this.props.clearModifications('items', _this.props.itemId);
      _this.props.clearModifications('quizEntries', _this.props.sessionItem.quizEntryId);
      _this.props.toggleRegradingEditMode('');
      _this.props.onCancel(_this.props.sessionItem.id);
    });
    _defineProperty(_this, "triggerRegradingModal", function (e) {
      var _this$props2 = _this.props,
        displayPosition = _this$props2.displayPosition,
        workingQuizEntry = _this$props2.workingQuizEntry,
        itemId = _this$props2.itemId;
      e && e.preventDefault();
      if (_this.isValid()) {
        _this.props.hideError(_this.props.guid);
        var _this$props$workingEn = _this.props.workingEntry,
          scoringAlgorithm = _this$props$workingEn.scoringAlgorithm,
          scoringData = _this$props$workingEn.scoringData;
        var pointsPossible = workingQuizEntry.regradeAdjustedPointsPossible(itemId) || workingQuizEntry.pointsPossible;
        _this.props.setRegradingPayload({
          itemId: _this.props.itemId,
          quizEntryId: _this.props.quizEntry.id,
          pointsPossible: pointsPossible,
          scoringAlgorithm: scoringAlgorithm,
          scoringData: scoringData
        });
        _this.props.openModal(REGRADE_MODAL);
      } else {
        var msg = t('Question {displayPosition, number} cannot be saved due to invalid input data.', {
          displayPosition: displayPosition
        });
        _this.props.screenreaderNotification(msg);
        _this.props.showError(_this.props.guid);
      }
    });
    _defineProperty(_this, "setAlertRef", function (node) {
      _this.alertNode = node;
    });
    _defineProperty(_this, "renderActionFooter", function () {
      return jsx("div", null, jsx(Button, {
        margin: "small",
        onClick: _this.turnOffRegradingEditMode
      }, t('Cancel')), jsx(Button, {
        margin: "small",
        color: "primary",
        onClick: _this.triggerRegradingModal,
        "data-automation": "sdk-trigger-regrade-button"
      }, t.rich('Regrade <0>question {position, number}</0>', {
        0: function _(_ref) {
          var children = _ref.children;
          return jsx(ScreenReaderContent, {
            key: "0"
          }, children);
        },
        position: _this.props.quizEntry.position
      })));
    });
    return _this;
  }
  _inherits(RegradeOverride, _Component);
  return _createClass(RegradeOverride, [{
    key: "quizEntryProps",
    value: function quizEntryProps() {
      return _objectSpread(_objectSpread({}, this.props), {}, {
        alternativeRightFooter: this.renderActionFooter,
        changeItemTitle: noop,
        clearModifications: noop,
        clearTemporaryItem: noop,
        cloneQuizEntry: noop,
        connectDragPreview: noop,
        connectDragSource: noop,
        createItem: noop,
        createQuizEntry: noop,
        disabledForRegrade: true,
        draggingAboveHalf: false,
        draggingOver: false,
        haveValidationErrorsFromApi: Boolean(Object.values(this.props.validationErrorsFromApi).length),
        hideError: noop,
        isOccluded: false,
        itemFeedbackOn: false,
        name: '',
        openModal: noop,
        openRegradeModal: noop,
        quizEntries: List(),
        removeQuizEntry: noop,
        screenreaderNotification: noop,
        setUi: noop,
        shouldClone: false,
        showError: noop,
        switchOffEditing: noop,
        updateItem: noop,
        updateQuizEntry: noop,
        withConfirm: noop
      });
    }
  }, {
    key: "itemEditProps",
    value: function itemEditProps() {
      return _objectSpread(_objectSpread({}, this.props), {}, {
        handleQuizEntryPointsChange: this.handleQuizEntryPointsChange,
        openImportModal: function openImportModal() {},
        parentId: this.props.quizId,
        parentType: PARENT_TYPE_QUIZ,
        title: this.props.entry.title,
        workingItem: this.props.workingEntry
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.quizEntry.id === '0') {
        this.props.getQuizEntry(this.props.quizId, this.props.sessionItem.quizEntryId);
      }
      if (!this.props.entry.isLoaded()) {
        this.props.getItem(this.props.itemId);
      } else {
        this.navigateToTop();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.entry.isLoaded() && this.props.entry.isLoaded()) {
        this.navigateToTop();
      }
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return this.props.workingEntry.isValid() && this.props.workingQuizEntry.isValid();
    }
  }, {
    key: "renderRegradingAlert",
    value: function renderRegradingAlert() {
      return jsx("div", null, jsx(Alert, {
        margin: "small 0",
        transition: "none",
        variant: "info"
      }, jsx("div", {
        css: this.props.styles.alert
      }, t.rich('<0>Regrading only applies to completed submissions.</0><1>If all students are affected please wait for all submissions before Regrading.</1>', [function (_ref2) {
        var children = _ref2.children;
        return jsx(Text, {
          as: "div",
          weight: "bold",
          key: "0"
        }, children);
      }, function (_ref3) {
        var children = _ref3.children;
        return jsx(Text, {
          as: "span",
          key: "1"
        }, children);
      }]))), jsx(Alert, {
        margin: "small 0",
        transition: "none",
        variant: "info"
      }, jsx("div", {
        css: this.props.styles.alert
      }, t.rich("<0>You are regrading this question.</0>\n              <1>Regrade options for this question type:</1>\n              <2>\n                <3>change the correct answer</3>\n                <4>change points value for the whole question</4>\n                <5>change points values on individual answers (if applicable)</5>\n              </2>", [function (_ref4) {
        var children = _ref4.children;
        return jsx(Text, {
          as: "div",
          weight: "bold",
          key: "0"
        }, children);
      }, function (_ref5) {
        var children = _ref5.children;
        return jsx(Text, {
          as: "span",
          key: "1"
        }, children);
      }, function (_ref6) {
        var children = _ref6.children;
        return jsx("ul", {
          key: "2"
        }, children);
      }, function (_ref7) {
        var children = _ref7.children;
        return jsx("li", {
          key: "3"
        }, children);
      }, function (_ref8) {
        var children = _ref8.children;
        return jsx("li", {
          key: "4"
        }, children);
      }, function (_ref9) {
        var children = _ref9.children;
        return jsx("li", {
          key: "5"
        }, children);
      }]))));
    }
  }, {
    key: "renderEditableView",
    value: function renderEditableView() {
      var propsForInteraction = propsForInteractionEdit(this.itemEditProps());
      var interactionType = this.props.entry.getInteractionType().slug;
      var Interaction = componentForItem(interactionType, COMPONENT_EDIT);
      return jsx(UndecoratedQuizEntryEdit, this.quizEntryProps(), this.renderRegradingAlert(), jsx("div", {
        css: this.props.styles.container
      }, jsx(Interaction, Object.assign({}, propsForInteraction, {
        itemId: this.props.sessionItem.id,
        overrideEditableForRegrading: true
      }))));
    }
  }, {
    key: "render",
    value: function render() {
      return jsx("div", {
        tabIndex: "-1",
        ref: this.setAlertRef
      }, jsx(RegradingModal, {
        fromSpeedgrader: true,
        quizId: this.props.quizId,
        handleValidationErrorsFromApi: this.props.handleValidationErrorsFromApi
      }), this.props.quizEntry.id !== '0' ? this.renderEditableView() : jsx(Spinner, null));
    }
  }]);
}(Component), _defineProperty(_RegradeOverride, "displayName", 'RegradeOverride'), _defineProperty(_RegradeOverride, "componentId", "Quizzes".concat(_RegradeOverride.displayName)), _defineProperty(_RegradeOverride, "propTypes", {
  appContainer: CustomPropTypes.selectors.isRequired,
  changeQuizEntryPoints: PropTypes.func.isRequired,
  entry: ImmutablePropTypes.record.isRequired,
  hideError: PropTypes.func.isRequired,
  guid: PropTypes.string.isRequired,
  workingEntry: ImmutablePropTypes.record.isRequired,
  clearModifications: PropTypes.func.isRequired,
  getItem: PropTypes.func.isRequired,
  getQuizEntry: PropTypes.func.isRequired,
  itemId: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  quizEntry: ImmutablePropTypes.record.isRequired,
  workingQuizEntry: ImmutablePropTypes.record.isRequired,
  quizId: PropTypes.string.isRequired,
  sessionItem: ImmutablePropTypes.record.isRequired,
  setRegradingPayload: PropTypes.func.isRequired,
  showError: PropTypes.func.isRequired,
  toggleRegradingEditMode: PropTypes.func.isRequired,
  handleValidationErrorsFromApi: PropTypes.func.isRequired,
  validationErrorsFromApi: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    text: PropTypes.string
  }))),
  // required by propsForInteractionEdit
  addError: PropTypes.func.isRequired,
  changeItemState: PropTypes.func.isRequired,
  displayPosition: PropTypes.number.isRequired,
  errorsAreShowing: PropTypes.bool,
  interactionFileUpload: PropTypes.func.isRequired,
  oneQuestionAtATime: PropTypes.bool.isRequired,
  partialDeepScoringEnabled: PropTypes.bool,
  partialScoringEnabled: PropTypes.bool,
  parentId: PropTypes.string.isRequired,
  parentType: PropTypes.string.isRequired,
  screenreaderNotification: PropTypes.func.isRequired,
  setOneQuestionAtATime: PropTypes.func.isRequired,
  styles: PropTypes.object
}), _defineProperty(_RegradeOverride, "defaultProps", {
  errorsAreShowing: false,
  partialScoringEnabled: false,
  partialDeepScoringEnabled: false,
  validationErrorsFromApi: {}
}), _RegradeOverride)) || _class);
export default RegradeOverride;